import classes from './MedirexLoginBox.module.scss';
import LoginTypeSwitcher from '../LoginTypeSwitcher';
import { Button, Input } from '@medio/ui';
import At from '../../assets/at.svg';
import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

interface MedirexLoginBoxProps {
	loginTitle: any;
	loginType: string;
	setLoginType?: any;
	handleMedirexLogin?: (state: any) => void;
	translates?: any;
}

export function MedirexLoginBox(props: MedirexLoginBoxProps) {
	const [state, setState] = useState({
		email: '',
		password: '',
	});

	// const handleForgotPassword = () => {
	// 	console.log('forgot password');
	// };

	const [loading, setLoading] = useState(false);

	return (
		<div className={classes.MedirexLoginBox}>
			<h3 className={classes.LoginTitle}>{props.loginTitle}</h3>
			<p className={classes.LoginDescription}>
				{props.translates
					? props.translates.login_description
					: 'A bejelentkezéshez kérjük válassza ki a platformot, majd adja meg e-mail címét és jelszavát.'}
			</p>
			<LoginTypeSwitcher loginType={props.loginType} setLoginType={props.setLoginType} />
			<form action="https://medirex.dokirex.hu/login" method="post">
				<div className={classes.formItem}>
					<span className={classes.formItemTitle}>
						{props.translates ? props.translates.email : 'E-mail cím'}
					</span>
					<div id="emailInput" className={classes.InputWrapper}>
						<Input
							type="email"
							name="username"
							required={true}
							className={classes.CustomInput}
							onChange={(event: { target: { value: any } }) =>
								setState({ ...state, email: event.target.value })
							}
							value={state.email}
						/>
						<img className={classes.InputIcon} src={At} alt="Email input icon" />
					</div>
				</div>
				<div className={classes.formItem}>
					<span className={classes.formItemTitle}>
						{props.translates ? props.translates.password : 'Jelszó'}
					</span>
					<div id="pwInput" className={classes.InputWrapper}>
						<Input
							type="password"
							name="password"
							required={true}
							className={classes.CustomInput}
							onChange={(event: { target: { value: any } }) =>
								setState({ ...state, password: event.target.value })
							}
							value={state.password}
							onEnter={props.handleMedirexLogin}
						/>
					</div>
				</div>
				<div className={classes.actionsContainer}>
					{/* <Button
          className={classes.forgotButton}
          text={props.translates ? props.translates.forgot_password : 'Elfelejtette jelszavát?'}
          onClick={handleForgotPassword}
        /> */}
					{/* <Button
					className={classes.nextButton}
					text={props.translates ? props.translates.login : 'Bejelentkezés'}
					onClick={() => {
						if (props.handleMedirexLogin) props.handleMedirexLogin(state);
					}}
				/> */}
					<button
						onClick={() => {
							setLoading(true);
						}}
						className={classes.nextButton}
					>
						{!loading ? (
							props.translates.login
						) : (
							<div className={classes.rotating}>
								<FontAwesomeIcon icon={faCircleNotch} />
							</div>
						)}
					</button>
				</div>
			</form>
		</div>
	);
}
